import * as Yup from 'yup';

const newRegistro = {
    data: '',
    obs: '',
    itens: [],
};

const validation = Yup.object().shape({
    data: Yup.date()
        .required('Este campo é obrigatório'),
    obs: Yup.string()
        .max(1000, 'Campo deve ter menos do que 1000 caracteres'),
});

export const implantacaoAnimal = {
    newRegistro,
    validation
}